export default __webpack_public_path__ + "static/media/lebensborn_250.3c235699.png";